import React, { useEffect, useState } from 'react'
import A4Page from '../A4Page'
import TopDetail from '../TopDetail'
import { ReactComponent as Zaraön } from '../../../../../assets/Varlık2.svg'
import useOrderStore from 'store/client/orderStore'
import { IoTriangleOutline } from 'react-icons/io5'
import { IoTriangle } from 'react-icons/io5'
import { ReactComponent as ZaraBom } from '../../../../../assets/DD.svg'
import { ReactComponent as ZaraBomRed } from '../../../../../assets/DDRED.svg'
import { ReactComponent as AUDDOLAR } from '../../../../../assets/DDRED.svg'
import { ReactComponent as ZaraAcc } from '../../../../../assets/zaraaccess01.svg'
import { ReactComponent as ZaraAccLinge } from '../../../../../assets/linnngee.svg'
import { ReactComponent as ZaraAccEmty } from '../../../../../assets/accesemty.svg'
import { ReactComponent as ZaraAccLin } from '../../../../../assets/accesslin.svg'
import { ReactComponent as CardFront3292 } from '../../../../../assets/waist/3292backwaist.svg';
import { ReactComponent as WTZCAL0 } from '../../../../../assets/waist/WTZCALL002.svg';
import { ReactComponent as CardFront } from '../../../../../assets/zarahome/defaulthome.svg';
import { ReactComponent as CardFrontKid } from '../../../../../assets/zarahome/defaulthomekids.svg';

import { ReactComponent as ZaraFscrr } from '../../../../../assets/globalsymbol/fscsimsekbest.svg'
import { ReactComponent as ZaraFsctm } from '../../../../../assets/globalsymbol/harmanbest.svg'
import { ReactComponent as ZaraFsctmpaper } from '../../../../../assets/globalsymbol/rpackbest.svg'

import { ReactComponent as CardDeneme } from '../../../../../assets/waist/waistemty.svg';
import { ReactComponent as CardTry1 } from '../../../../../assets/cleanedtry.svg';
import requests from 'service/api'


const loadSVG = async (sizeData) => {
  try {
   const referenceCode = sizeData?.referanceCode;

   function parseSize(ref = "") {
    const m = ref.match(/(\d+(?:[.,]\d+)?)\s*x\s*(\d+(?:[.,]\d+)?)/i);
    if (!m) return null;
    const [w, h] = [m[1], m[2]].map(s => parseFloat(s.replace(',', '.')));
    return { width: w, height: h };
  }
  
  const size = parseSize(sizeData?.referanceCode);
    const referenceWidth = size?.width;
    const referenceHeight = sizeData?.height;
    console.log("geldi",sizeData);
    if (!referenceCode) {
      console.log('[loadSVG] referenceCode bulunamadı');
      return null;
    }

    const raw = referenceCode.toString();
    const cleanedCode = raw.trim().replace(/\s+/g, ''); // boşlukları tamamen kaldır

    console.log(`[loadSVG] Gelen kod: "${raw}" -> Kullanılan kod: "${cleanedCode}"`);

    if (cleanedCode.toUpperCase() === 'BACK') {
      return null;
    }

    // dosya adında boşluk istemediğin için cleanedCode gönderiyoruz
    const response = await requests.order.getBrandSvgHome(cleanedCode, { type: 'belt' });

    // SVG string'ini React component'ine çevir
    let svgString = response.data;

    // SVG'ye width/height ekle
    const parser = new DOMParser();
    const doc = parser.parseFromString(svgString, 'image/svg+xml');
    const svgElement = doc.querySelector('svg');

    if (svgElement) {
      svgElement.setAttribute('width', `${referenceWidth}mm`);
      svgElement.setAttribute('height', `${referenceHeight}mm`);
      svgString = new XMLSerializer().serializeToString(doc);
    }

    return () => (
      <div
        style={{ width: `${referenceWidth}mm`, height: `${referenceHeight}mm`, position: 'relative' }}
        dangerouslySetInnerHTML={{ __html: svgString }}
      />
    );
  } catch (error) {
    console.error(`[loadSVG] SVG yüklenemedi. Kod: ${sizeData?.referenceCode}, Hata:`, error);
    //('hata verdi');
    return null;
  }
};

const renderDiv = (referenceCode, referenceWidth) => {
  let style = {
    width: "50.2mm",
    height: "102mm",
    position: "absolute",
    top: 0.4,
    left: -0.4,
    zIndex: 36,
    opacity: "1",
  };

  if (referenceCode.includes("CALL") && referenceWidth === 50) {
    style.width = "50.2mm";
    style.height = "102.2mm";
  } else if (referenceCode.includes("KALL") && referenceWidth === 50) {
    style.width = "50.2mm";
    style.height = "102.2mm";
  } else if (referenceCode.includes("KALL") && referenceWidth === 32) {
    style.width = "32.2mm";
    style.height = "92.1mm";
    style.top = 0;  
  }

  return (
    <div style={style}>
      <div style={{ width: style.width, height: style.height, border: style.border }}></div>
    </div>
  );
};


// FSC Component'lerin gösterilmeyeceği kodlar
const FSC_BLACKLIST = [
  "TYPE89 31x56",

  // Buraya gösterilmemesi gereken kodları ekleyebilirsiniz
];

// FSC Component pozisyonları - referanceCode'a göre
const getFSCPosition = (referanceCode,category) => {
  console.log("getFSCPosition - referanceCode:", referanceCode);
  
if(category === "Kids"){

  if (referanceCode?.includes("TYPE76 31x56")) {
    return { bottom: 7.4, right: 60 };
  } else if (referanceCode?.includes("TYPE91 31x56")) {
    return { bottom: 6.6, right: 59 };
  } else {
    
    return { bottom: 12.2, right: 55.5 };
  }
}
else
{
  if (referanceCode?.includes("TYPE76 31x56")) {
    return { bottom: 7.4, right: 60 };
  } else if (referanceCode?.includes("TYPE91 31x56")) {
    return { bottom: 6.6, right: 59 };
  } else {
    
    return { bottom: 14, right: 55.5 };
  }
}

 
};

// FSC Component'in gösterilip gösterilmeyeceğini kontrol eden fonksiyon
const shouldShowFSC = (referanceCode) => {
  if (!referanceCode) return false;
  
  // Blacklist'teki kodları kontrol et
  const isBlacklisted = FSC_BLACKLIST.some(blacklistedCode => 
    referanceCode.includes(blacklistedCode)
  );
  
  return !isBlacklisted;
};

// DynamicSVGComponent - her sizeData için ayrı SVG yükler
const DynamicSVGComponent = ({ sizeData, fallbackComponent, showFSC = false, data, selectedFscType,category }) => {
  const [svgComponent, setSvgComponent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [hasError, setHasError] = useState(false);
  alert(selectedFscType)
  console.log("DynamicSVGComponent - sizeData:", sizeData);
  console.log("DynamicSVGComponent - sizeData.referanceCode:", sizeData?.referanceCode);
  
  // FSC Component tanımları
  const FSC_COMPONENTS = {
    fscrr: { component: ZaraFscrr, width: "4.20mm ", height: "auto" },
    fsctm: { component: ZaraFsctm, width: "4.20mm", height: "auto" },
    fsctmpaper: { component: ZaraFsctmpaper, width: "5.860mm", height: "auto" },
  };
  
  const SelectedComponent = FSC_COMPONENTS[selectedFscType];
  const fscPosition = getFSCPosition(sizeData?.referanceCode,category);
  const canShowFSC = shouldShowFSC(sizeData?.referanceCode) && showFSC;
  
  useEffect(() => {
    if (sizeData?.referanceCode) {
      setLoading(true);
      setHasError(false);
      loadSVG(sizeData)
        .then((component) => {
          setSvgComponent(() => component);
          setLoading(false);
        })
        .catch((error) => {
          console.error("[DynamicSVGComponent] SVG yüklenirken hata:", error);
          setHasError(true);
          setLoading(false);
        });
    }
  }, [sizeData?.referanceCode]);

  if (loading) {
    return <span>Loading...</span>;
  }

  if (hasError || !svgComponent) {
    // Eğer fallbackComponent varsa onu göster, yoksa hata mesajı
    if (fallbackComponent) {
      return (
        <div style={{ position: 'relative' }}>
          {fallbackComponent}
          {canShowFSC && SelectedComponent && (
            <div style={{ position: 'absolute', ...fscPosition }}>
              <SelectedComponent.component
                width={SelectedComponent.width}
                height={SelectedComponent.height}
              />
            </div>
          )}
        </div>
      );
    }
    return <span>SVG bulunamadı</span>;
  }

  return (
    <div style={{ position: 'relative' }}>
      {svgComponent()}
      {canShowFSC && SelectedComponent && (
        <div style={{ position: 'absolute', ...fscPosition }}>
          <SelectedComponent.component
            width={SelectedComponent.width}
            height={SelectedComponent.height}
          />
        </div>
      )}
    </div>
  );
};

const BeltMainHome = ({ data, selectColor, tab }, ref) => {
  const department = data.department
  const [brand, category, subCategory] = department.split(' / ')
  const [SouthAmerica, setSouthAmerica] = useState(false)
  const [fscToLogo, setfscToLogo] = useState("var");

  const selectedFscType = data.company?.fsctype;
  const selectedFscTopLogo = data.company?.fsctoplogo;
console.log("dataaaaa",category)
  const [harmacn, setHarmacn] = useState(false) // harmacn state'i

  useEffect(() => {
    if (data.company?.fsctoplogo) {
      setfscToLogo(data.company?.fsctoplogo);
    }
  }, [data.company?.fsctoplogo]);

  // item.amount > 0 koşulunu sağlayan öğeleri filtrele ve her 8 öğede bir grupla
  const filteredAndGroupedSizes = data.beltLabel[selectColor].sizes
    .filter((item) => item.amount > 0)
    .reduce((acc, item, index) => {
      const groupIndex = Math.floor(index / 1) // Her 3 öğe için bir grup indeksi
      if (!acc[groupIndex]) {
        acc[groupIndex] = { items: [], startIndex: index - (index % 1) } // Yeni bir grup oluştur
      }
      acc[groupIndex].items.push(item)
      return acc
    }, [])

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }} ref={ref}>
      {filteredAndGroupedSizes.map((groupObj, groupIndex) => (
        <A4Page key={groupIndex} type="dikey">
          <div className="space-y-5" style={{ position: 'relative' }}>
            <TopDetail 
              values={data} 
              selectColor={selectColor} 
              tab={tab} 
              selectedFscTopLogo={data.company?.fsctoplogo || "defaultLogo"}
            />
            <div style={{ display: 'flex', justifyContent: 'flex-start', marginLeft: 22 }}>
              {groupObj.items.map((sizeData, index) => (
                console.log("sizeDataxxx",sizeData),
                <div key={groupObj.startIndex + index}>
                  <div
                    style={{
                
                      display: 'flex',
                      gap: '10px',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                  >
                    {/* Sol tarafta dinamik SVG - önce BACK versiyonunu dene */}
                    <div className="printable" style={{ position: 'relative',width:"40mm" }}>
                      <DynamicSVGComponent 
                        sizeData={{
                          ...sizeData,
                          referanceCode: sizeData.referanceCode + "BACK"
                        }} 
                        category={category}
                        fallbackComponent={
                          category === "Kids" 
                            ? <CardFrontKid width="31mm" height="56mm" />
                            : <CardFront width="31mm" height="56mm" />
                        }
                        showFSC={true}
                        data={data}
                        selectedFscType={selectedFscType}
                      />
                    </div>
                    
                    {/* Sağ tarafta loadSVG ile yüklenen SVG */}
                    <div className="printable" style={{ position: 'relative' }}>
                      {sizeData?.sCode ? (
                        <DynamicSVGComponent 
                          sizeData={sizeData} 
                          category={category}
                          showFSC={false}
                          data={data}
                          selectedFscType={selectedFscType}
                        />
                      ) : (
                        <span>Loading...</span>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </A4Page>
      ))}
    </div>
  )
}

export default React.forwardRef(BeltMainHome)
